<template>
  <div class="edu-banner-area banner03">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="edu-banner-content">
            <h1>
              Gelecek İçin Klasik <span class="shape01">Eğitim</span>
            </h1>
            <p>
              Okuyucunun dikkatini dağıtmayan içeriklerin uzun süredir tercih edildiği bilinen bir gerçektir.
            </p>
            <div class="edu-banner-btns">
              <a class="default-btn" href="#">Bugünden Öğrenmeye Başla</a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="edu-banner-image3">
            <img src="../../assets/img/banner/man3.png" alt="banner-img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBanner",
};
</script>